import axios from "axios";

const OWN_DOMAIN = /(^|\.)myxd\.it\.com$/.test(window.location.hostname);
export const API = `${OWN_DOMAIN ? window.location.origin : process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export const errCode = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    const codes = d.map((x) => String(x?.msg || "").replace(/^Value error, /, "")).filter(Boolean);
    return codes.find((c) => /^[a-z_]+$/.test(c)) || codes.join(" ");
  }
  return e?.message || "error";
};

export const media = (id, variant = "public") => `${API}/media/${id}/${variant}`;
